import React from 'react'
import { StructuredText } from 'react-datocms'
import { isEmpty } from 'lodash'

import * as styles from './structured-text-report.module.scss'

import Image from '@/components/image/image'

const StructuredTextReport = ({ content, className }) => {
  if (isEmpty(content?.value)) return <></>

  return (
    <div className={[styles.content, className].filter(Boolean).join(' ')}>
      <StructuredText
        data={content}
        renderBlock={({ record }) => {
          switch (record.__typename) {
            case 'DatoCmsTableContent':
              return (
                <div className={styles.tableContent}>
                  <p className={`${styles.number}`}>{record.number}</p>
                  <p className={`${styles.title} `}>{record.title}</p>
                  {record.content && (
                    <StructuredTextReport content={record.content} />
                  )}
                </div>
              )
            case 'DatoCmsColumnCard':
              return (
                <div className={styles.columnCard}>
                  <Image
                    image={record.image}
                    className={styles.columnCardImage}
                  />
                  <h6
                    className={`my-0 text-base-100 b200-bold ${styles.columnCardTitle}`}
                  >
                    {record.title}
                  </h6>
                  <p className={`${styles.columnCardText} my-0`}>
                    {record.text}
                  </p>
                </div>
              )
            default:
              return null
          }
        }}
      />
    </div>
  )
}

export default StructuredTextReport
